import { Dialog, DialogContent, Grid, Typography } from '@mui/material';
import { useState } from 'react';

import './styles.scss';
import { useSnackbar } from '../../../../../../components/Snackbar/hooks';
import { ActionButtonProps } from '../../interface';

import { Button } from '@components/ButtonV2';
import { useAppDispatch } from '@hooks/state';
import { removeCustomerRequest } from '@state/customer/actions';

export const RemoveModal = ({ userId }: ActionButtonProps): JSX.Element => {
  const [open, setOpen] = useState(false);
  const { showMessage } = useSnackbar();
  const dispatch = useAppDispatch();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOnClick = async () => {
    dispatch(
      removeCustomerRequest({
        userId,
        errorCallback: () => {
          showMessage('There was an error deleting the customer', {
            severity: 'error',
          });
        },
        successCallback: () => {
          showMessage('The customer has been deleted successfully', {
            severity: 'success',
          });
        },
      }),
    );

    handleClose();
  };

  return (
    <>
      <Button
        variant='outlined'
        className='bl-remove-modal-button'
        onClick={handleClickOpen}
        size='small'
      >
        Remove
      </Button>
      <Dialog
        className='bl-remove-modal-dialog-container'
        open={open}
        onClose={handleClose}
      >
        <DialogContent>
          <Typography className='bl-remove-modal-question' paragraph>
            Are you sure you want to remove this Customer from your dashboard?
          </Typography>

          <Typography className='bl-remove-modal-content' paragraph>
            You can undo this at any time by going into the &quot;Removed&quot;
            tab of this table.
          </Typography>

          <Grid container className='bl-remove-modal-buttons-container'>
            <Grid
              item
              xs={5}
              className='bl-remove-modal-cancel-button-container'
            >
              <Button
                variant='contained'
                color='secondary'
                onClick={handleClose}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item xs={5}>
              <Button variant='contained' onClick={handleOnClick}>
                Remove
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};
